<template>
    <PersonalInfoPolicy20260901Content />
</template>

<script>
import PersonalInfoPolicy20260901Content from '@/views/policy/common/PersonalInfoPolicy20260901Content.vue';

export default {
    name: 'PrivacyPolicy20260901',
    components: {
        PersonalInfoPolicy20260901Content,
    },
};
</script>
